import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BarChart3, Package, MessageSquare, Star, Calendar, LogOut, Menu, X, ChevronLeft } from 'lucide-react';
import Navbar from '../Common/Navbar'; 
import './AdminLayout.css';

const AdminLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarVisible, setSidebarVisible] = useState(true);

  const navigationItems = [
    { label: 'Dashboard', icon: BarChart3, link: '/admin/dashboard' },
    { label: ' Add Product', icon: Package, link: '/admin/products' },
    { label: 'Reviews', icon: MessageSquare, link: '/admin/draft-reviews' },
    { label: 'Testimonials', icon: Star, link: '/admin/testimonials' },
    { label: 'Demo Requests', icon: Calendar, link: '/admin/demo-requests' },
  ];

  const handleRouteNavigation = (link) => {
    navigate(link);
  };

  const handleAdminLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("tokenExpiry");
    localStorage.clear();
    navigate("/login");
  };

  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  return (
    <div className="admin-layout-container">
      {/* Pass toggleAdminSidebar to Navbar (separate from calculator sidebar) */}
      <Navbar toggleAdminSidebar={toggleSidebar} />

      {/* Admin Navigation Panel */}
      <aside className={`admin-navigation-panel ${sidebarVisible ? 'panel-visible' : 'panel-hidden'}`}>
        <div className="navigation-brand">
          <div className="brand-icon">
            <BarChart3 size={24} />
          </div>
          <h2 className="brand-title">Admin Control</h2>
          <button
            className="navigation-close-btn"
            onClick={toggleSidebar}
            aria-label="Close navigation"
            title="Close sidebar"
          >
            <ChevronLeft size={20} />
          </button>
        </div>

        <nav className="navigation-menu">
          {navigationItems.map((item, index) => (
            <button
              key={index}
              className={`navigation-item ${location.pathname === item.link ? 'navigation-item-active' : ''}`}
              onClick={() => handleRouteNavigation(item.link)}
            >
              <item.icon size={20} className="navigation-icon" />
              <span className="navigation-label">{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="navigation-footer">
          <button className="navigation-item navigation-logout" onClick={handleAdminLogout}>
            <LogOut size={20} className="navigation-icon" />
            <span className="navigation-label">Logout</span>
          </button>
        </div>
      </aside>

      {/* Main Content Area */}
      <main className={`admin-content-wrapper ${sidebarVisible ? 'content-shifted' : 'content-full'}`}>
        {/* Mobile Navigation Toggle */}
        <button
          className="admin-mobile-toggle"
          onClick={toggleSidebar}
          aria-label="Toggle navigation menu"
        >
          {sidebarVisible ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Page Content */}
        <div className="admin-page-content">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;